import React from "react";
import PropTypes from "prop-types";

/* eslint-disable jsx-a11y/label-has-for */
const InputField = ({
  type,
  name,
  value,
  label,
  description,
  onInputChange,
}) => (
  <div className={`form-item form-item--${name}`}>
    <label className="form-required" htmlFor={name}>
      {label}:
    </label>
    <input
      type={type}
      name={name}
      className="comments-form__item"
      id={name}
      value={value}
      onChange={(e) => onInputChange(e.target.name, e.target.value)}
      maxLength="90"
      required
    />
    {description && <span className="description">{description}</span>}
  </div>
);

InputField.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  onInputChange: PropTypes.func.isRequired,
};

InputField.defaultProps = {
  value: "",
  description: "",
};

export default InputField;
